import request from '@/mixins/request'

export default {
  mixins: [request],

  methods: {
    async loaddatasource() {
      const resp = await this.$api.get(
        `/schedules/apicallogs/thirdlogs/alldatasource`
      )
      if (resp.data.status === 1) {
        return (resp.data.content || []).map(d => ({
          value: d,
          label: d,
        }))
      }
    },

    async loadrequest(index, id) {
      return await this.$api.get(`/schedules/apicallogs/thirdlogdetail`, {
        params: {
          id: id,
          index: index,
        },
      })
    },

    async loadAllServices() {
      const resp = await this.$api.get(
        '/schedules/apicallogs/firstlogs/allservice'
      )

      if (resp.data.status === 1) {
        return (resp.data.content || []).map(it => ({
          label: it.toUpperCase(),
          value: it,
        }))
      }
    },
  },

  created() {
    let service,
      _loadAllServices = this.loadAllServices
    this.loadAllServices = () => service || (service = _loadAllServices())
  },
}
